module.exports = __webpack_public_path__ + "static/patekphilippe-ad86c84657c89933f03af7362caff755.png";